import { render, staticRenderFns } from "./EmailBroadcast.vue?vue&type=template&id=a2f16728"
import script from "./EmailBroadcast.vue?vue&type=script&lang=js"
export * from "./EmailBroadcast.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcast.vue?vue&type=style&index=0&id=a2f16728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports